import React from 'react';
import { ArrowLeft, Eye, Shield } from 'lucide-react';
import { Button } from '../ui/Button';
import { Banner } from '../ui/Banner';
interface ViewingLearnerBannerProps {
  learnerName: string;
  portalName: string;
  onReturn: () => void;
}
export function ViewingLearnerBanner({
  learnerName,
  portalName,
  onReturn
}: ViewingLearnerBannerProps) {
  const isAdmin = portalName === 'Beheer';
  return <Banner variant={isAdmin ? 'warning' : 'assignment'} icon={isAdmin ? Shield : Eye} className="z-50 relative rounded-none sm:rounded-none border-x-0 border-t-0" action={<Button variant="outline" size="sm" onClick={onReturn} className="bg-white whitespace-nowrap" data-id="element-2778" data-mp="4bqwjvqwjejc">
        
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2779" data-mp="9alnxm2xqbf2" />
          Terug naar {portalName}
        </Button>} data-id="element-2777" data-mp="dc6wwwccm5jz">
      
      {isAdmin ? 'Admin: ' : ''}Je bekijkt nu het dashboard van{' '}
      <strong className="font-black" data-id="element-2780" data-mp="3ql1u9oqg5qn9">{learnerName}</strong>
    </Banner>;
}